import * as yup from 'yup';

import { ESignSignerAuthMethod } from '@breathelife/types';

export const getAuthMethodSchema = (): yup.MixedSchema =>
  yup.mixed<ESignSignerAuthMethod>().oneOf(Object.values(ESignSignerAuthMethod));
